var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327.568,
    height: 248,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ccc",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M45.811 1h262.53M45.811 28.732h262.53M45.811 55.725h262.53M45.811 81.978h262.53M45.811 108.97h262.53M45.811 136.702h262.53M45.811 162.955h262.53M45.811 189.948h262.53M45.811 216.94h262.53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b72b9",
    d: "M65.778 135.593h45.111v106.491H65.778zM131.595 135.593h45.111v107.231h-45.111zM197.412 54.985h45.111v187.099h-45.111zM263.23 27.623h45.111v214.461H263.23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M327.568 242.084H45.071V1",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M87.963 248v-5.916M154.15 247.26v-5.916M219.968 247.26v-5.916M285.046 248v-5.916"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.558 89.343a58.223 58.223 0 0 0-44.63 95.006L1.676 225.755a6.3 6.3 0 0 0 .311 8.867 6.172 6.172 0 0 0 4.311 1.671 6.3 6.3 0 0 0 4.518-1.982l39.986-41.147A58.262 58.262 0 1 0 86.558 89.343zm33.2 90.273a45.68 45.68 0 1 1 13.082-32.435 45.459 45.459 0 0 1-13.078 32.435z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.845 147.18a45.728 45.728 0 1 1-13.7-32.184 45.4 45.4 0 0 1 13.7 32.184z",
    fill: "#0b72b9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f2f2f2",
    fontSize: 10,
    fontFamily: "Courier-Oblique, Courier",
    fontStyle: "oblique"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(82.332 110.867)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "11")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(58.781 123.164)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "001000101")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(49.994 135.462)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "011101001010")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(46.14 147.759)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1000101010101")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(47.08 160.056)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "011011001001")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(52.456 172.353)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "00111011100")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(63.996 184.651)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1010001"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.d03f9bf2e364313fc1eda99c33e996ef.svg";
export { ForwardRef as ReactComponent };